import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import { Button } from '../button';
import { PDKSidebarToggleIcon } from '../pdk-icons';
import { useSidebar } from '../sidebar';

const HeaderWithSidebarToggle = ({ children }: { children: ReactNode }) => {
  const { openMobile, setOpenMobile } = useSidebar();
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-row w-full items-center">
      {isMobile && (
        <Button
          onClick={() => setOpenMobile(!openMobile)}
          variant="ghost"
          size="sm"
          className={cn('h-6 border-muted-foreground/20 text-xs')}
        >
          <PDKSidebarToggleIcon open={openMobile} />
        </Button>
      )}

      <div className="flex flex-row grow w-full items-center h-full">
        {children}
      </div>
    </div>
  );
};

export default HeaderWithSidebarToggle;
